import {useState, useEffect } from "react";

export const useTitle = (newTitle) => { //set browser tab name for accessibility
    useEffect(() => {
        const prevTitle = document.title;
        document.title = newTitle;
        return () => document.title = prevTitle;
    });
}

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};